import React from 'react';
import CommunityViewNew from './CommunityViewNew';

/**
 * Variante A: tarjeta de horarios semanales **a la derecha del header**
 * (junto al nombre y los botones). En desktop xl+, layout 2-col; en mobile,
 * apilados.
 *
 * URL: /communities1/:id
 */
export default function CommunityView1() {
  return <CommunityViewNew scheduleCardPlacement="header-right" />;
}
